import api from '../../api/countries'
import {
  COUNTRIES_LIST
} from '../actions/countries'

const state = {
  countriesFull: []
}

const getters = {
  countries: state => state.countriesFull
}

const actions = {
  [COUNTRIES_LIST]: async function ({commit, state}) {
    if (state.countriesFull.length) {
      return 200
    }
    try {
      const res = await api.getAllCountries()
      commit(COUNTRIES_LIST, res)
      return res.status
    } catch (err) {
      console.log(err)
      return err.response.status
    }
  }
}

const mutations = {
  [COUNTRIES_LIST]: (state, res) => {
    state.countriesFull = res.data.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/countries.js